module.exports = Jsw.skinUrl + "/images/sticker-collection/badge-stars.png?6f0eb925096d2e114e501aa776e78c79";